module Meevo.Plugins.Product {
    export class VariantAdjustUsagePricingController {
        static $inject = [
            "$mdDialog",
            "$translate",
            "meevo.components.modal.ModalService",
            "options"
        ];

        public chargeEnabled : boolean;
        public salesButtonLabel: string;
        public selectedChargeType?: Meevo.Model.ProductVariantChargeTypeEnum = null;
        public enteredChargeAmount: number = 0;
        public perItemPriceLabel: string;

        constructor(
            private $mdDialog: angular.material.IDialogService,
            private $translate: angular.translate.ITranslateService,
            private modalService: Meevo.Components.Modal.IModalService,
            private options: VariantAdjustUsagePricingOptions) {
            this.chargeEnabled = (options.variant.chargeType != null && options.variant.chargeType != Meevo.Model.ProductVariantChargeTypeEnum.None);
            if (this.chargeEnabled) {
                this.selectedChargeType = options.variant.chargeType;
            }
            this.enteredChargeAmount = options.variant.chargeAmount;

            this.perItemPriceLabel = options.product.productUsageType == Meevo.Model.ProductUsageAmountTypeEnum.PartialAmount ? "LABEL_USAGETRACK_PER_UNIT" : "LABEL_USAGETRACK_PER_PRODUCT";
        }


        $onInit() { 

        }

        getProductDescription() {
            let desc: string = `${this.options.variant.sku} : ${this.options.product.displayName}`;
            if (this.options.variant.displayName) {
                desc += ` - ${this.options.variant.displayName}`;
            }
            desc += ` : ${this.options.variant.barCode}`;
            return desc;
        }

        closeModal(e): void {
            if (e) e.stopPropagation();
            this.$mdDialog.hide();
        }

        applyChanges(e): void {
            if (!this.chargeEnabled) {
                this.options.variant.chargeType = Meevo.Model.ProductVariantChargeTypeEnum.None;
            }
            else {
                if (this.selectedChargeType != null) {
                    this.options.variant.chargeType = this.selectedChargeType;
                }
                else {
                    this.modalService.alert(`Please select either '${this.$translate.instant("LABEL_USAGETRACK_FLAT_FEE")}' or '${this.$translate.instant("LABEL_USAGETRACK_PER_PRODUCT")}'.`, Components.Modal.ModalTranslationModes.DoNotTranslate, true);
                    return;
                }
            }

            this.options.variant.chargeAmount = this.enteredChargeAmount;

            if (e) e.stopPropagation();
            this.$mdDialog.hide();
        }
    }

    angular.module("meevo.plugins.product")
        .controller("meevo.plugins.product.VariantAdjustUsagePricingController", VariantAdjustUsagePricingController);
}